import React, { useState, useEffect, useContext, useMemo } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import "./report.scss";
import "react-toastify/dist/ReactToastify.css";
import masterApi from "../../services/masterApi";
import Loader from "../../components/loader/Loader";
import DatePicker from "react-datepicker";
import { format } from "date-fns"; // Use date-fns for date formatting
import ExportToExcel from "../../components/exportExcel/ExportToExcel";
import CalendarIcon from "../../assets/icons/CalendarIcon";
import ResetIcon from "../../assets/icons/ResetIcon";
import { getRoStatusName } from "../../utils/common";
const Report = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [status, setStatus] = useState("");
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchData = async () => {
    try {
      const response = await masterApi.report();
      setTasks(response?.data?.repairorderList);
    } catch (error) {
    } finally {
    }
  };
  useEffect(() => {
    const currentDate = new Date();
    // Subtract 7 days (1 week)
    currentDate.setDate(currentDate.getDate() - 7);
    // Update the state with the date 1 week ago
    setFromDate(currentDate.toISOString().split("T")[0]); // Formats the date to 'YYYY-MM-DD'
    setToDate(new Date()); // Formats the date to 'YYYY-MM-DD'
    fetchData();
  }, []); // Empty dependency array means it runs once on component mount

  // Reset filters to initial state
  const resetFilters = () => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 7); // 7 days ago
    setFromDate(currentDate.toISOString().split("T")[0]);
    setToDate(new Date().toISOString().split("T")[0]); // Today
    setStatus(""); // Reset status filter
    fetchData(); // Re-fetch the data with default filters
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");

    // Build the query parameters
    let queryParams = `?fromdate=${fromDate}&todate=${toDate}`;
    if (status) {
      queryParams += `&status=${status}`;
    }

    try {
      // Make the API call to fetch tasks report
      const response = await masterApi.report(queryParams);
      setTasks(response?.data?.repairorderList);
    } catch (err) {
      setError("Failed to fetch tasks report");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL",
  };

  const columns = [
    {
      name: "RO Number",
      selector: (row) => <div className="table-cell">{row.roNumber}</div>,
    },
    {
      name: "Customer Name",
      selector: (row) => <div className="table-cell">{row.customerName}</div>,
    },
    {
      name: "Status",
      selector: (row) => {
        //const status = row.roStatus;
        //const capitalizedStatus = status.charAt(0).toUpperCase() + status.slice(1); // Capitalizes the first letter
        return <div className="table-cell">{ getRoStatusName(row.roStatus) } </div>;
      },
    },
    {
      name: "Start Date",
      selector: (row) => (
        <div className="table-cell">
          {format(new Date(row.createdAt), "MM-dd-yyyy")}
        </div>
      ),
    },
    {
      name: "Completed Date",
      selector: (row) => {
        if (row.roCompletedDate == null) {
          return <div className="table-cell">-</div>; // or return an empty string, "N/A", etc.
        }

        const date = new Date(row.roCompletedDate);
        // Check if the date is valid
        if (isNaN(date)) {
          return <div className="table-cell">-</div>; // or return an empty string or another fallback value
        }
        return <div className="table-cell">{format(date, "MM-dd-yyyy")}</div>;
      },
    },
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="report">
          <form onSubmit={handleSubmit}>
            <div className="report-head">
              <div className="report-left">
                <div className="form-box">
                  <label>From Date:</label>
                  <div className="date">
                    <DatePicker
                      selected={fromDate}
                      onChange={(date) => setFromDate(date)}
                      dateFormat="MM-dd-YYYY" // This adds the custom format directly
                      maxDate={new Date()} // Disable dates after toDate
                      onChangeRaw={(e) => e.preventDefault()}
                      className="date-input form-control"
                    />
                    <span className="icon">
                      <CalendarIcon />
                    </span>
                  </div>
                </div>
                <div className="form-box">
                  <label>To Date:</label>
                  <div className="date">
                    <DatePicker
                      selected={toDate}
                      onChange={(date) => setToDate(date)}
                      dateFormat="MM-dd-YYYY" // This adds the custom format directly
                      maxDate={new Date()} // Disable dates before fromDate
                      onChangeRaw={(e) => e.preventDefault()}
                      className="date-input form-control"
                    />
                    <span className="icon">
                      <CalendarIcon />
                    </span>
                  </div>
                </div>
                <div className="form-box">
                  <label>Status :</label>
                  <div className="status">
                    <select
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      className="form-control"
                    >
                      <option value="">All</option>
                      <option value="completed">Completed</option>
                      <option value="delayed">Delayed</option>
                      <option value="inProgress">In Progress</option>
                      <option value="unassigned">Unassigned</option>
                      <option value="notStarted">Not Started</option>
                    </select>
                  </div>
                </div>
                <button className="primary-btn" type="submit" disabled={loading}>
                  {loading ? "Loading..." : "Get Report"}
                </button>
                {/* Reset Button */}
                <button
                  type="button"
                  className="secondary-btn"
                  onClick={resetFilters}
                  disabled={loading}
                >
                  <ResetIcon/>
                </button>
              </div>
              <div className="report-right">
                <ExportToExcel data={tasks} />
              </div>
            </div>
            <div className="report-table">
              <DataTable
                columns={columns}
                data={tasks}
                fixedHeader
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[5, 10, 20]}
                paginationComponentOptions={paginationComponentOptions}
                highlightOnHover
                responsive
              />
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default Report;
